import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';

function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: '',
    company: '',
    phone: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = 'E-posta adresi gerekli';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Geçerli bir e-posta adresi girin';
    }

    if (!formData.password) {
      newErrors.password = 'Şifre gerekli';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Şifre en az 6 karakter olmalı';
    }

    if (!isLogin) {
      if (!formData.name) {
        newErrors.name = 'Ad Soyad gerekli';
      }

      if (!formData.confirmPassword) {
        newErrors.confirmPassword = 'Şifre tekrarı gerekli';
      } else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = 'Şifreler eşleşmiyor';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      if (isLogin) {
        alert('Giriş başarılı! Dashboard\'a yönlendiriliyorsunuz...');
        // Redirect to dashboard
        window.location.href = '/dashboard';
      } else {
        alert('Kayıt başarılı! Giriş yapabilirsiniz.');
        setIsLogin(true);
        setFormData({
          email: '',
          password: '',
          confirmPassword: '',
          name: '',
          company: '',
          phone: ''
        });
      }
    }, 2000);
  };

  const toggleMode = () => {
    setIsLogin(!isLogin);
    setErrors({});
    setFormData({
      email: '',
      password: '',
      confirmPassword: '',
      name: '',
      company: '',
      phone: ''
    });
  };

  return (
    <div className="login">
      <div className="login-container">
        <div className="login-header">
          <div className="logo">
            <span className="logo-icon">⚡</span>
            <span className="logo-text">Enerji Takip</span>
          </div>
          <h1>{isLogin ? 'Giriş Yap' : 'Hesap Oluştur'}</h1>
          <p>
            {isLogin 
              ? 'Hesabınıza giriş yaparak enerji tüketiminizi takip etmeye devam edin'
              : 'Yeni hesap oluşturarak enerji tasarrufu yolculuğunuza başlayın'
            }
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {!isLogin && (
            <div className="form-group">
              <label htmlFor="name">Ad Soyad</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className={errors.name ? 'error' : ''}
                placeholder="Adınız ve soyadınız"
              />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">E-posta</label>
            <input
              type="email"
              id="email"
              name="email"
              autoComplete="email"
              value={formData.email}
              onChange={handleInputChange}
              className={errors.email ? 'error' : ''}
              placeholder="ornek@email.com"
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="password">Şifre</label>
            <input
              type="password"
              id="password"
              name="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleInputChange}
              className={errors.password ? 'error' : ''}
              placeholder="Şifrenizi girin"
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          {!isLogin && (
            <div className="form-group">
              <label htmlFor="confirmPassword">Şifre Tekrarı</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                className={errors.confirmPassword ? 'error' : ''}
                placeholder="Şifrenizi tekrar girin"
              />
              {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
            </div>
          )}

          {!isLogin && (
            <div className="form-group">
              <label htmlFor="company">Şirket (İsteğe Bağlı)</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleInputChange}
                placeholder="Şirket adınız"
              />
            </div>
          )}

          {!isLogin && (
            <div className="form-group">
              <label htmlFor="phone">Telefon (İsteğe Bağlı)</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="+90 5XX XXX XX XX"
              />
            </div>
          )}

          {isLogin && (
            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" />
                <span className="checkmark"></span>
                Beni hatırla
              </label>
              <span className="forgot-link" style={{cursor:'default', opacity:0.6}}>
                Şifremi unuttum
              </span>
            </div>
          )}

          <button 
            type="submit" 
            className="submit-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="loading">
                <span className="spinner"></span>
                {isLogin ? 'Giriş yapılıyor...' : 'Kayıt oluşturuluyor...'}
              </span>
            ) : (
              <span>
                {isLogin ? '🚀 Giriş Yap' : '📝 Hesap Oluştur'}
              </span>
            )}
          </button>

          <div className="form-footer">
            <p>
              {isLogin ? 'Hesabınız yok mu?' : 'Zaten hesabınız var mı?'}
              <button type="button" className="toggle-button" onClick={toggleMode}>
                {isLogin ? 'Hesap Oluştur' : 'Giriş Yap'}
              </button>
            </p>
          </div>
        </form>

        <div className="login-features">
          <h3>🎯 Giriş yapın ve şunları keşfedin:</h3>
          <ul>
            <li>📊 Gerçek zamanlı enerji takibi</li>
            <li>💰 Maliyet analizi ve tasarruf önerileri</li>
            <li>📱 Mobil uygulama erişimi</li>
            <li>🔔 Akıllı bildirimler</li>
            <li>📈 Detaylı raporlama</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Login;
